module.exports = __webpack_public_path__ + "static/media/art_gallery.251d38c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/art_gallery.jpg
// module id = 151
// module chunks = 0